module.exports = __webpack_public_path__ + "img/mailian_banner.85ceea32.jpg";